import React, {useEffect, useState, useRef} from 'react';
import {useTariff} from 'contexts/Tariff';
import ArrowDown from 'components/ui/icon/ArrowDown';
import Cross from 'components/ui/icon/Cross';
import {Title, TitleSize, TitleLevel} from 'components/ui/Title';
import Modal from 'components/layout/Modal';
import {TARIFFS} from 'data/tariffs';
import pluralize from 'utils/pluralize';
import Checkmark from 'components/ui/icon/Checkmark';

import './TariffPreview.scss';

const TariffPreview = ({slug}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const tariffAPI = useTariff();
  const chosenServices = tariffAPI.getSupplements(slug);
  const isCustomTariff = slug === 'custom';

  const previewListRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(isPreviewOpen ? previewListRef?.current?.scrollHeight || 0 : 0);
  }, [isPreviewOpen]);

  useEffect(() => {
    setIsPreviewOpen(false);
  }, [tariffAPI.tariffState]);

  if (chosenServices.length <= 0) {
    return null;
  }

  return (
    <div
      className={`tariff-preview ${
        isPreviewOpen ? 'tariff-preview_open' : 'tariff-preview_closed'
      }`}
    >
      <div
        className="tariff-preview__info"
        onClick={() => setIsPreviewOpen(prev => !prev)}
      >
        <div className="tariff-preview__info_top">
          <ArrowDown extraClassName="tariff-preview__arrow-down" />

          <div className="tariff-preview__info-name tariff-preview_mobile">
            Тариф «{TARIFFS[slug].name}»
          </div>
          <div className="tariff-preview__info-name tariff-preview_desktop">
            {pluralize(chosenServices.length, 'Выбрана', 'Выбраны', 'Выбрано')}{' '}
            {chosenServices.length}{' '}
            {!isCustomTariff &&
              pluralize(
                chosenServices.length,
                'дополнительная ',
                'дополнительные ',
                'дополнительных ',
              )}
            {pluralize(chosenServices.length, 'работа', 'работы', 'работ')}
          </div>

          <div
            className="tariff-preview__cross-wrapper"
            onClick={e => {
              e.stopPropagation();
              setIsModalOpen(true);
            }}
          >
            Сбросить
            <Cross color="#979797" extraClassName="tariff-preview__cross" />
          </div>
        </div>

        <div className="tariff-preview__info_bottom tariff-preview_mobile">
          {chosenServices.length} работ
        </div>
      </div>

      <div
        className="tariff-preview__list-wrapper"
        ref={previewListRef}
        style={{height, transition: 'height 0.3s ease'}}
      >
        <ul className="tariff-preview__list">
          {chosenServices.map((chosenService, index) => (
            <li key={index} className="tariff-preview__service">
              <Checkmark color="black" />
              {chosenService.name}
            </li>
          ))}
        </ul>
      </div>

      <p className="tariff-preview__caption">
        Расчёт предварительный. Для более точного расчёта отправьте заявку или
        уточните параметры в&nbsp;Telegram.
      </p>

      {isModalOpen && (
        <TariffPreviewModal
          onSubmit={() => {
            tariffAPI.purge(slug);
            setIsModalOpen(false);
          }}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

const TariffPreviewModal = ({onSubmit, onClose}) => {
  return (
    <Modal extraClassName="tariff-preview__modal" onClose={onClose}>
      <Title
        extraClassName="care__card-title"
        level={TitleLevel.H3}
        size={TitleSize.H3}
      >
        Сбросить параметры ремонта?
      </Title>

      <div className="tariff-preview__modal_bottom">
        <button
          className="tariff-preview__modal-button tariff-preview__modal-close"
          onClick={onClose}
        >
          Отмена
        </button>

        <button
          className="tariff-preview__modal-button tariff-preview__modal-submit"
          onClick={onSubmit}
        >
          Да
        </button>
      </div>
    </Modal>
  );
};

export default TariffPreview;
